import React, { Fragment } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import EditBtn from '../../buttons/EditBtn'
import NullMssg from '../../common/NullMssg'
import { mssgs } from '../../../constantes/mssgs'
import _ from 'lodash'

const PositionsList = (
    {
        allDepartaments,
        handleRemove,
        userProfile,
        openEditModal,
    }
) => {

    allDepartaments = _.orderBy(allDepartaments, ['nombre'],['asc'])

    return (
        <Fragment>
            <table>
                <thead>
                    <tr>
                        <th>
                            Nombre
                        </th>
                        <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allDepartaments ? allDepartaments.map((departament, i) =>
                            <tr key={i}>
                                <td className="table-td-header">
                                    <p className="products__text">{departament.nombre}</p>
                                </td>
                                <td className="table-td-actions">
                                    <button onClick={() => openEditModal(departament.id_TipoDepartamento)}><EditBtn /></button>
                                    <button onClick={() => handleRemove(departament.id_TipoDepartamento)}><DeleteBtn /></button>
                                </td>
                            </tr>
                        ) : <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_DEPARTAMENTOS}/>
                    }
                </tbody>
            </table>
        </Fragment>
    )
}
export default PositionsList